// Components
import { IFormInstance } from '@/components';
import { StyledForm } from './SeoFormStyles';

// Models
import { SupportedLocales } from '@/models/localization.model';
import { ICategoryDetails } from '@/models/categories.model';

// Modules
import { MetaTagHints, MetaTagsTabs } from '@/modules/MetaTags';

// Helpers
import { normalizeSeoData } from '../../helpers/normalizeSeoData';
import { useSeoValidationRules } from '../../hooks';

const initialLocale = {
  [SupportedLocales.UK]: { seo_title: '', seo_description: '', keywords: [] },
  [SupportedLocales.RU]: { seo_title: '', seo_description: '', keywords: [] },
};

type TSeoForm = {
  onSubmit: (values: ICategoryDetails) => void;
  isLoading: boolean;
  formInstance: IFormInstance;
  categoryDetails: ICategoryDetails | null;
};

const SeoForm = ({ formInstance, onSubmit, categoryDetails }: TSeoForm) => {
  const initialValues = categoryDetails ? normalizeSeoData(categoryDetails) : initialLocale;
  const rules = useSeoValidationRules();

  return (
    <StyledForm initialValues={initialValues} onFinish={onSubmit} form={formInstance}>
      <MetaTagsTabs hint={MetaTagHints.CATEGORIES} rules={rules} />
    </StyledForm>
  );
};

export default SeoForm;
